module.exports = __webpack_public_path__ + "static/media/9C.cf6317bc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/9C.svg
// module id = 81
// module chunks = 0